import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkle } from 'lucide-react';
export function HeroSection() {
  const checkoutUrl = 'https://kreanacrochet.com/cart/add?id=52738305032303&quantity=1';
  return <section className="relative pt-16 pb-20 md:pt-24 md:pb-32 overflow-hidden bg-gradient-warm" data-id="element-115">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-soft-rose/10 blur-3xl rounded-full -translate-y-1/2 translate-x-1/4" data-id="element-116" />
      <div className="absolute bottom-0 left-0 w-1/4 h-2/3 bg-soft-sage/10 blur-3xl rounded-full translate-y-1/4 -translate-x-1/4" data-id="element-117" />

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-118">
        {/* Headline + Subtitle */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-119">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-deep-brown leading-tight mb-6" data-id="element-120">
            Convierte a tu Mascota en un{' '}
            <span className="text-warm-brown italic" data-id="element-121">Amigurumi Eterno</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-600 mb-0 leading-relaxed max-w-2xl mx-auto" data-id="element-122">
            No es solo un patrón. Es la oportunidad de tejer un recuerdo{' '}
            <span className="font-bold text-soft-rose" data-id="element-123">
              idéntico a tu mejor amigo peludo
            </span>
            , capturando su esencia en cada puntada.
          </p>
        </motion.div>

        {/* Real Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-3xl mx-auto mb-10" data-id="element-124">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-white p-2 md:p-3" data-id="element-125">
            <img src="https://cdn.magicpatterns.com/uploads/njYLEmLyW4kqydiKCQMP29/20260225_1747_Image_Generation_simple_compose_01kjb8vcmxecnb2ptf3s7evtje.png" alt="Bulldog Francés real junto a su versión amigurumi tejida a crochet — comparación lado a lado" className="w-full rounded-xl" data-id="element-126" />
          </div>

          {/* Floating Badge */}
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 1,
          duration: 0.5
        }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl max-w-[200px] hidden md:block" data-id="element-127">
            <div className="flex items-center gap-2 mb-2" data-id="element-128">
              <div className="text-yellow-400 flex text-sm" data-id="element-129">★★★★★</div>
            </div>
            <p className="text-xs text-gray-600 italic" data-id="element-130">
              "Lloré cuando terminé de tejer a mi Toby. Es idéntico."
            </p>
          </motion.div>
        </motion.div>

        {/* CTA below image */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-col items-center gap-5" data-id="element-131">
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="group relative px-10 py-4 bg-deep-brown text-white rounded-full font-bold text-lg shadow-lg hover:shadow-xl hover:bg-warm-brown transition-all duration-300 flex items-center gap-2 transform hover:-translate-y-1" data-id="element-132">
            Quiero Tejer a Mi Mascota
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-133" />
          </a>

          <span className="text-warm-brown font-medium text-sm tracking-wide flex items-center gap-1.5" data-id="element-134">
            <Sparkle size={14} className="text-soft-rose" data-id="element-135" />
            Ebook Digital – Descarga Inmediata
          </span>

          <div className="flex items-center gap-2 text-sm text-warm-brown/70 font-medium" data-id="element-136">
            <div className="flex -space-x-2" data-id="element-137">
              {[1, 2, 3].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs overflow-hidden" data-id="element-138">
                  <div className={`w-full h-full ${i === 1 ? 'bg-blue-100' : i === 2 ? 'bg-pink-100' : 'bg-yellow-100'}`} data-id="element-139" />
                </div>)}
            </div>
            <span data-id="element-140">+1,200 tejedoras felices</span>
          </div>
        </motion.div>
      </div>
    </section>;
}